import React from 'react';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

import { classNames } from 'utils/classNames';

const baseClassName = 'WorkspaceSidebarTopSection';

/**
 * Used for keeping styles aligned with the WorkspaceTopbar
 */
const WorkspaceSidebarTopSection = (props) => {
    const className = classNames({
        [baseClassName]: true,
        [props.className]: !!props.className,
    });

    return <SuiContainer {...props} className={className} />;
};

WorkspaceSidebarTopSection.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

WorkspaceSidebarTopSection.defaultProps = {
    className: null,
    children: [],
};

export default WorkspaceSidebarTopSection;
